import React from 'react'
import s from './Contact.module.css'
import ContactUsForm from '../../components/contactUsForm/ContactUsForm'
import MyPopupSendSuccess from '../../components/ui/MyPopupSendSuccess/MyPopupSendSuccess'
import { useAppSelector } from '../../hooks/redux'
import { motion } from 'framer-motion'
import { EnvironmentOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import Hero from '../../components/hero/Hero'
import { useLocation } from 'react-router-dom'
import { CONTACT } from '../../router/Constants'
import telegram_icon_light from '../../assets/img/telegram_icon_light.svg'
import whatsapp_icon_light from '../../assets/img/whatsapp_icon_light.svg'
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const location = useLocation()
  const isSuccess: boolean | null = useAppSelector(
    state => state.userReducer.isMessageSentSuccess
  )
  const { t } = useTranslation();

  return (
   <motion.div
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className={s.motion_div}> 

        {location.pathname === CONTACT && (
          <div className={s.content}>
            <Hero
                title_1={t('contactPage.heroTitle1')}
                title_2={t('contactPage.heroTitle2')}
                description={t('contactPage.heroDescription')}
            />
          </div>
        )}

    <div className={s.content}>
      <div className={s.container}>
        {isSuccess ? <MyPopupSendSuccess /> : <></>}
        <div className={s.leftColumn}>
        <ContactUsForm />
      </div>
      <div className={s.rightColumn}>
        <div className={s.rightColumnContent}>
          <h1 className={s.heading}>{t('contactPage.heading')}</h1>
          <p className={s.paragraph}>{t('contactPage.paragraph')}</p>

          <div className={s.contactSection}>
          <div className={s.iconHeading}>
            <EnvironmentOutlined className={s.icon} />
            <div className={s.contentHeading}>{t('contactPage.representativeOfficeTitle')}</div>
          </div>
          <div className={s.contentDesc}>
          <p>No. 802 Renmin Avenue,</p>
          <p>Changchun City, Jilin Province</p>
          </div>
        </div>

        <div className={s.contactSection}>
          <div className={s.iconHeading}>
            <MailOutlined className={s.icon} />
            <div className={s.contentHeading}>{t('contactPage.ourEmailTitle')}</div>
          </div>
          <p className={s.contentDesc}>info@wallsteetibu.com</p>
        </div>

        <div className={s.contactSection}>
          <div className={s.iconHeading}>
            <PhoneOutlined className={s.icon} />
            <div className={s.contentHeading}>{t('contactPage.contactTitle')}</div>
          </div>
          <div className={s.social}>
            <a href='https://t.me/WallstreetIBU'>
              <img className={s.icon} src={telegram_icon_light} alt="telegram" />
            </a>
            <a href='https://wa.me/+35796145664'>
              <img className={s.icon} src={whatsapp_icon_light} alt="whatsapp" />
            </a>
          </div>
        </div>
        </div>
      </div>
    </div>
    </div>
   </motion.div> 
  )
}

export default Contact
